import { ArrowDownToLine } from "lucide-react";
import { isNative } from "@/lib/mobile";
import androidLogo from "@/assets/android.svg";

export default function AndroidDownload({ compact = false }) {
  if (isNative) return null;
  return <a
    href="/downloads/ProCrypto.apk"
    download="ProCrypto.apk"
    className={compact
      ? "inline-flex items-center gap-1.5 rounded-xl border border-[#3DDC84]/35 bg-[#3DDC84]/10 px-2.5 py-2 text-xs font-semibold text-[#3DDC84] shrink-0 hover:bg-[#3DDC84]/20"
      : "group flex items-center gap-4 rounded-2xl border border-[#3DDC84]/40 bg-gradient-to-r from-[#123026] to-[#101C21] p-4 shadow-lg shadow-emerald-950/20 hover:border-[#3DDC84]/70 transition-colors"}
    aria-label="Install the ProCrypto Android app"
    title="Install the app for Android"
  >
    <span className={compact ? "shrink-0" : "w-12 h-12 rounded-xl bg-[#3DDC84]/10 flex items-center justify-center shrink-0"}><img src={androidLogo} alt="" aria-hidden="true" className={compact ? "w-5 h-5" : "w-8 h-8"} /></span>
    {compact ? <span className="hidden min-[390px]:inline">Install app</span> : <>
      <span className="flex-1 min-w-0"><span className="block font-display text-base font-bold text-white">Install the app</span><span className="block mt-0.5 text-xs text-[#A8CDBB]">For Android · Download APK</span></span>
      <ArrowDownToLine size={20} className="text-[#3DDC84] shrink-0" aria-hidden="true" />
    </>}
  </a>;
}
